import { GitBranch } from "lucide-react";
import React from "react";
import { Tooltip } from "./Tooltip";

const stackTooltip = (stack) => {
	if (stack.isStackStart) {
		const blockedMrs = stack.blocks || [];
		if (blockedMrs.length === 1) {
			return `Stack ${stack.stackPosition}/${stack.stackSize}. Review this before #${blockedMrs[0].iid}.`;
		}
		if (blockedMrs.length > 1) {
			const examples = blockedMrs
				.slice(0, 3)
				.map((mr) => `#${mr.iid}`)
				.join(", ");
			const suffix =
				blockedMrs.length > 3 ? `, and ${blockedMrs.length - 3} more` : "";
			return `Stack ${stack.stackPosition}/${stack.stackSize}. Review this before ${examples}${suffix}.`;
		}
		return `Stack ${stack.stackPosition}/${stack.stackSize}. Review this first.`;
	}

	return stack.blockedBy
		? `Stack ${stack.stackPosition}/${stack.stackSize}. Review after #${stack.blockedBy.iid}: ${stack.blockedBy.title}${stack.blockedBy.external ? " (not on your dashboard)" : ""}.`
		: `Stack ${stack.stackPosition}/${stack.stackSize}.`;
};

export const StackIndicator = ({ mr, compact = false }) => {
	const stack = mr?.stack;
	if (!stack?.isStacked) return null;

	const isStart = stack.isStackStart;
	const label = isStart
		? "First in stack"
		: stack.blockedBy
			? `After #${stack.blockedBy.iid}`
			: "Stacked";

	return (
		<Tooltip content={stackTooltip(stack)}>
			<span
				className={`inline-flex items-center gap-1 rounded border px-1.5 py-0.5 text-xs font-medium ${
					isStart
						? "border-emerald-500/40 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300"
						: "border-[var(--color-border)] bg-[var(--color-bg-secondary)] text-[var(--color-text-secondary)]"
				}`}
			>
				<GitBranch className="w-3.5 h-3.5 flex-shrink-0" aria-hidden="true" />
				<span>{`${stack.stackPosition}/${stack.stackSize}`}</span>
				{!compact && <span>{label}</span>}
			</span>
		</Tooltip>
	);
};
